// Citations for `StudioEvidence`. A `source_document` carries the page's original
// URL, title and publisher; a `platform_aggregate` has no URL by contract, so it is
// cited by platform and post count only. Evidence is external, untrusted data: only
// http(s) URLs become links, and contradicted evidence is never cited.
const PRIMARY = ['regulatory_primary', 'clinical_primary', 'public_statement'];

export const safeUrl = value => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url : null;
  } catch { return null; }
};

export const hostName = url => url?.hostname.replace(/^www\./, '') || '';

// The site's name: the publisher, else the host.
export const siteName = (evidence, url = safeUrl(evidence.url)) => evidence.publisher?.trim() || hostName(url);

export const faviconUrl = url => `https://www.google.com/s2/favicons?domain=${encodeURIComponent(url.hostname)}&sz=32`;

export const citable = (evidence = []) => evidence.filter(item => item.kind === 'platform_aggregate'
  || (item.kind === 'source_document' && item.verification !== 'contradicted' && safeUrl(item.url)));

// The one source named "official": a verified primary document, then any verified
// document, then the first document.
export const officialSource = (evidence = []) => {
  const documents = citable(evidence).filter(item => item.kind === 'source_document');
  return documents.find(item => item.verification === 'verified' && PRIMARY.includes(item.category))
    || documents.find(item => item.verification === 'verified') || documents[0] || null;
};

// The evidence a generated revision cites (`script.evidence_ids`), resolved through
// the project's sourced topic. A revision that cites none falls back to the evidence
// the brief was written from.
export const revisionEvidence = (topic, revision, brief) => {
  if (!topic?.evidence || !revision) return [];
  const cited = revision.script?.evidence_ids || [];
  const ids = cited.length ? cited : brief?.evidence_ids || [];
  return citable(topic.evidence.filter(item => ids.includes(item.id)));
};
